<template>
    <div>
        <FindMemberIdsTogetherWithCustomer/>
    </div>
</template>

<script>
import FindMemberIdsTogetherWithCustomer from '../components/FindMemberIdsTogetherWithCustomer.vue';

export default {
    name: "ManageMemberIdsTogetherWithCustomer",
  components: {
    FindMemberIdsTogetherWithCustomer,
  },
}
</script>